const AUTOFILL_COOKIE_KEY = "lea_dev_autofill";

const getCookieValue = (key: string): string | undefined => {
	if (typeof document === "undefined") return undefined;
	return document.cookie
		.split("; ")
		.find((entry) => entry.startsWith(`${key}=`))
		?.split("=")[1];
};

/** Whether dev-mode mock autofill defaults should be applied to the forms. */
export const isAutofillEnabled = (devConsole: boolean): boolean =>
	devConsole && getCookieValue(AUTOFILL_COOKIE_KEY) !== "off";

/** Toggles the mock autofill preference. Client-only; takes effect after a reload. */
export const setAutofillEnabled = (enabled: boolean) => {
	document.cookie = `${AUTOFILL_COOKIE_KEY}=${enabled ? "on" : "off"}; path=/; SameSite=Lax`;
};
